import React from "react";
import { useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";


const Logo = ({height = 32, style, ...boxProps }) => {

  const brandingProps = useSelector(state => state.login.brandingProps);
  const alt = brandingProps && brandingProps.name ? brandingProps.name : "Logo";
  const fileName = brandingProps?.fileName ? brandingProps.fileName : "";
  return (
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/${fileName}`}
      alt={alt}
      height={height}
      style={style}
      {...boxProps}
    />
  );
};

Logo.propTypes = {
  height: PropTypes.number,
  style: PropTypes.object,
};

export default Logo;
